import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Tabs, Tab } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';

import BusinessIcon from '@material-ui/icons/Business';
import PinDropIcon from '@material-ui/icons/PinDrop';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import CurrencyGbpIcon from 'mdi-react/CurrencyGbpIcon';

import Overview from './overview/Overview';
import Nearby from './nearby/Nearby';
import PlanningTab from './planning/PlanningTab';
import Value from './value/Value';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { setTabIndex } from '../../../../redux/parcel/Actions';
import { hidePrimaryPanel } from '../../../../redux/panel/Actions';

const StyledTab = withStyles((theme) => ({
    root: {
        ...theme.typography.tab,
        minHeight: 'initial',
        minWidth: 'initial',
        color: theme.palette.text.inactive,
        padding: '0px 0px',
        height: '35px',
        flexGrow: 1,
        '&:hover': {
            color: theme.palette.secondary.light
        }
    },
    wrapper: {
        flexDirection: 'row',
        lineHeight: 1,
        '&> *:first-child': {
            marginBottom: 'initial !important',
            marginRight: '5px',
            width: '15px',
            height: '15px'
        }
    },
    selected: {
        color: theme.palette.secondary.light
    }
}))(Tab);

class PropertyInfo extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        tabIndex: PropTypes.number.isRequired,
        isParcelLayerActive: PropTypes.bool.isRequired,
        // Redux Dispatch
        dispatchSetTabIndex: PropTypes.func.isRequired,
        dispatchHidePrimaryPanel: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleTabChangeIndex = this.handleTabChangeIndex.bind(this);
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        // Ideally move this elsewhere so this is not reliant on been on a panel
        if (prevProps.isParcelLayerActive && !this.props.isParcelLayerActive) { this.props.dispatchHidePrimaryPanel(); }
    }

    handleTabChange (event, newValue) {
        const { dispatchSetTabIndex } = this.props;
        dispatchSetTabIndex(newValue);
    }

    handleTabChangeIndex = (index) => {
        const { dispatchSetTabIndex } = this.props;
        dispatchSetTabIndex(index);
    };

    render () {
        const { classes, tabIndex } =this.props;
        return (
            <div className={classes.root}>
                <Tabs
                    classes={{
                        root: classes.tabsRoot,
                        indicator: classes.tabsIndicator
                    }}
                    value={tabIndex}
                    onChange={this.handleTabChange}
                >
                    <StyledTab label="Overview" icon={<BusinessIcon />} />
                    <StyledTab label="Nearby" icon={<PinDropIcon />} />
                    <StyledTab label="Planning" icon={<HowToVoteIcon />} />
                    <StyledTab label="Value" icon={<CurrencyGbpIcon />} />
                    {/* <StyledTab label="Addressbase" icon={<MapIcon/>}/> */}
                </Tabs>
                <SwipeableViews
                    axis="x"
                    index={tabIndex}
                    onChangeIndex={this.handleTabChangeIndex}
                    containerStyle={{ height: '100%' }}
                >
                    <Overview />
                    <Nearby />
                    <PlanningTab />
                    <Value />
                </SwipeableViews>
            </div>
        );
    }
}

const style = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    tabsRoot: {
        height: '35px',
        minHeight: 'initial',
        flexShrink: 0,
        position: 'relative',
        '&::after': {
            content: '""',
            background: `${theme.palette.background.border}33`,
            height: '2px',
            position: 'absolute',
            left: 0,
            bottom: 0,
            right: 0
        }
    },
    tabsIndicator: {
        backgroundColor: theme.palette.secondary.light,
        zIndex: 1
    }
});

const mapStateToProps = (state) => {
    const layer = state.activeLayers.find(e => e.uid === 'hmlr_land_parcels');
    return {
        isParcelLayerActive: Boolean(layer && (layer.pinned || layer.visible)),
        tabIndex: state.parcelPanel.tabIndex
    };
};

const mapDispatchToProps = (dispatch) => ({
    dispatchSetTabIndex: (index) => dispatch(setTabIndex(index)),
    dispatchHidePrimaryPanel: () => dispatch(hidePrimaryPanel())
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(PropertyInfo);